// import react from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export function AboutUs() {
    const {t} = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("lang"));
    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem("lang"));
    },[]);
    useEffect(()=>{
        console.log('use effect local storage', localStorage.getItem("lang"));
    },[currentLanguage]);
    const dynamicStyle={
        'text-align':localStorage.getItem("lang")==="ar"? 'right':'left',
        'listStyleType': localStorage.getItem("lang")==="ar"?'none':null
    }
    return (
        <div>
            <h1 style={dynamicStyle}>{t("welcome")}</h1>
            <p style={dynamicStyle}>{t("summary")}</p>
            <h1 style={dynamicStyle}>{t("Objectives_titles")}</h1>
            <ul style={dynamicStyle}>{t("Objectives_points").split(".").map((item,index)=>(
                <li style={dynamicStyle} key={index}>{item}</li>
            ))}</ul>
        </div>)
}
export function Page2() {
    return (
        <div>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti delectus ad vero doloremque et obcaecati
                asperiores magni fugiat labore? Rem, vitae. Doloremque earum, distinctio odio a perferendis repellendus rerum
                eos quidem voluptatum quaerat corporis. Aliquam maiores omnis, veritatis iste, totam voluptatibus illo
                pariatur ipsa harum mollitia voluptatum atque illum deserunt molestias temporibus voluptatem laudantium.
                Qui eos voluptas veniam omnis aspernatur mollitia praesentium rem neque quisquam consectetur assumenda,
                dicta, ratione perferendis molestiae porro autem! Animi voluptatem praesentium temporibus sequi in non,
                debitis obcaecati quasi, aut recusandae quis distinctio hic pariatur possimus, qui deserunt. Architecto
                deleniti fugit nam recusandae, quidem odio a nihil ducimus omnis, distinctio consequatur velit inventore
                laboriosam ipsa adipisci fuga voluptatum cupiditate quae. Placeat quam neque corporis quidem atque eaque
                pariatur consectetur, sit nisi quo esse vitae iste, nostrum necessitatibus dignissimos magnam beatae blanditiis
                cum odio explicabo vel, libero incidunt! Omnis ipsum quis eum ratione, maiores doloremque eveniet quidem nihil
                ad suscipit voluptatibus sint iusto inventore nemo repellendus laborum magnam sit? Dolorem officia atque quod id
                optio eum nam quo ipsa molestias consequuntur mollitia inventore voluptatum natus beatae praesentium perferendis
                voluptas, quisquam harum suscipit quia ea? Quod veritatis nam dolorum tempore porro nemo voluptatum qui expedita
                eaque blanditiis ducimus, mollitia, sunt saepe minus molestiae facere corporis autem aperiam, cumque voluptatem?
                Nesciunt, ipsam, eligendi id nam optio error corrupti ut obcaecati necessitatibus accusantium maiores aliquam cum
                aspernatur cumque commodi similique unde temporibus sapiente adipisci architecto ex eius cupiditate! Beatae,
                fugit autem magnam veritatis laboriosam quasi obcaecati praesentium ut assumenda iure sapiente dolorum,
                cumque modi reiciendis tempore placeat ipsum similique laborum et, incidunt repellendus velit! Fugiat excepturi,
                harum quis voluptate reiciendis voluptatum. Nostrum deserunt natus error repudiandae vitae aut minus cum sequi
                exercitationem sunt ipsa dolores iusto repellendus, nobis consequatur eius quaerat pariatur similique sint nulla.
                Esse cumque voluptate harum quia.
            </p>
        </div>)
}
export function Page3() {
    return (
        <div>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam quo ex at hic blanditiis quae voluptatibus,
                laborum excepturi ut vitae ullam neque! Quasi, facere fugit repellendus possimus commodi doloremque quidem
                recusandae reiciendis alias velit? Voluptatem, totam. Consectetur aspernatur rem alias atque ratione veritatis
                odio quam dolor nobis voluptatibus? Itaque laboriosam, veniam ipsum non dolor rem nam blanditiis.
                Fugit possimus quis magni repellendus iusto, ipsa, suscipit aperiam dicta velit minima dolor tenetur amet nam
                debitis ullam error ut cum aliquid odit?
            </p>
        </div>)
}
export function Page4() {
    return (
        <div>
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur ex eaque id dignissimos cum voluptates
                maxime deleniti, eos, beatae consectetur sit hic corporis numquam praesentium, laborum obcaecati dolores
                amet suscipit reiciendis cumque assumenda deserunt odit. Accusantium debitis, deleniti, maxime reiciendis
                aut culpa consectetur illo, cumque aliquid perspiciatis nihil ex quas ut fugit in veniam quaerat obcaecati
                enim? Voluptates ipsam aliquam qui atque natus eum expedita nobis consectetur facilis vero tempora, delectus
                architecto nulla, exercitationem nemo nostrum, placeat sequi quia autem. Ut ducimus aliquid accusantium
                nesciunt earum veritatis eius id tempora, consequatur eaque nisi omnis corporis quod nobis sit, quae,
                dolorum maxime autem! Ex ipsum dolor veniam. Qui molestiae saepe nesciunt impedit maxime voluptatibus
                pariatur sunt voluptate corrupti, eligendi quibusdam hic.
            </p>
        </div>)
}